"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.SecurityException = exports.Exception = exports.ContentType = exports.MimeType = exports.Language = exports.TranslatedString = exports.Money = exports.Currency = exports.WeightUnitConverter = exports.WeightUnit = exports.CountryConverter = exports.Country = exports.Image = exports.ImageSize = exports.Dimensions3D = exports.MediaBuilder = exports.Media = exports.PointOfView3D = exports.Alignment = void 0;
var Alignment;
(function (Alignment) {
    Alignment["TOP_LEFT"] = "TOP_LEFT";
    Alignment["TOP_CENTER"] = "TOP_CENTER";
    Alignment["TOP_RIGHT"] = "TOP_RIGHT";
    Alignment["CENTER_LEFT"] = "CENTER_LEFT";
    Alignment["CENTER"] = "CENTER";
    Alignment["CENTER_RIGHT"] = "CENTER_RIGHT";
    Alignment["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    Alignment["BOTTOM_CENTER"] = "BOTTOM_CENTER";
    Alignment["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var PointOfView3D = /** @class */ (function () {
    function PointOfView3D() {
    }
    PointOfView3D.identical = function (c1, c2) {
        return c1.pitch === c2.pitch && c1.radius === c2.radius && c1.yaw === c2.yaw;
    };
    PointOfView3D.defaultPointOfView3D = { pitch: 0, yaw: 1.90 /* 1.57 is straight */, radius: 25 };
    PointOfView3D.pieceIdealPointOfView3D = { pitch: 0, yaw: 1.90 /* 1.57 is straight */, radius: 25 };
    PointOfView3D.necklaceIdealPointOfView3D = { yaw: Math.PI * 0.5, pitch: 0, radius: 18 };
    PointOfView3D.availablePointsOfView3D = [
        { pitch: 0, yaw: 2.2, radius: 25 },
        { pitch: 0, yaw: 1.9, radius: 25 },
        { pitch: 0, yaw: 1.5, radius: 25 },
        { pitch: 0, yaw: 1.3, radius: 25 },
        { pitch: 0, yaw: 1.1, radius: 25 }
    ];
    return PointOfView3D;
}());
exports.PointOfView3D = PointOfView3D;
var Media = /** @class */ (function () {
    function Media() {
    }
    Media.isValidWithContentType = function (media, contentType) {
        return ((media.contentBase64 !== undefined || media.url !== undefined) && media.contentType === contentType);
    };
    Media.withUrl = function (oldMedia, newUrl) {
        if (oldMedia === Media.UNDEFINED) {
            throw new Exception("Current media object is Media.UNDEFINED and as such cannot update the url withot updating the contentType as well");
        }
        return __assign(__assign({}, oldMedia), { url: newUrl });
    };
    Media.UNDEFINED = {
        contentType: 'undefined'
    };
    return Media;
}());
exports.Media = Media;
var MediaBuilder = /** @class */ (function () {
    function MediaBuilder(media) {
        this.media = media;
    }
    MediaBuilder.initialiseWithUrl = function (url, contentType) {
        return new MediaBuilder({
            url: url,
            contentType: contentType
        });
    };
    MediaBuilder.initialiseWithContentBase64 = function (contentBase64, contentType) {
        return new MediaBuilder({
            contentBase64: contentBase64,
            contentType: contentType
        });
    };
    MediaBuilder.initialiseWithUrlAndContentBase64 = function (url, contentBase64, contentType) {
        return new MediaBuilder({
            url: url,
            contentBase64: contentBase64,
            contentType: contentType
        });
    };
    MediaBuilder.prototype.isValidWithContentType = function (contentType) {
        return Media.isValidWithContentType(this.media, contentType);
    };
    MediaBuilder.prototype.build = function () {
        return this.media;
    };
    return MediaBuilder;
}());
exports.MediaBuilder = MediaBuilder;
var Dimensions3D = /** @class */ (function () {
    function Dimensions3D() {
    }
    Dimensions3D.allDimensionsHigherThan = function (dimensions3D, threshold) {
        return (dimensions3D.width > threshold && dimensions3D.height > threshold && dimensions3D.depth > threshold);
    };
    return Dimensions3D;
}());
exports.Dimensions3D = Dimensions3D;
var ImageSize;
(function (ImageSize) {
    ImageSize["SMALL"] = "SMALL";
    ImageSize["MEDIUM"] = "MEDIUM";
    ImageSize["LARGE"] = "LARGE";
})(ImageSize = exports.ImageSize || (exports.ImageSize = {}));
var Image = /** @class */ (function () {
    function Image() {
    }
    Image.withUrl = function (oldImage, newMediaUrl) {
        return __assign(__assign({}, oldImage), { media: Media.withUrl(oldImage.media, newMediaUrl) });
    };
    Image.UNDEFINED = {
        hash: '',
        size: ImageSize.MEDIUM,
        media: Media.UNDEFINED
    };
    return Image;
}());
exports.Image = Image;
var Country;
(function (Country) {
    Country["CHINA"] = "CHINA";
    Country["HONG_KONG"] = "HONG_KONG";
    Country["NETHERLANDS"] = "NETHERLANDS";
    Country["UNITED_STATES"] = "UNITED_STATES";
})(Country = exports.Country || (exports.Country = {}));
var CountryConverter = /** @class */ (function () {
    function CountryConverter() {
    }
    CountryConverter.countryCode2Country = function (twoLetterCountryCode) {
        return this.map.get(twoLetterCountryCode);
    };
    CountryConverter.map = new Map([
        ['CN', Country.CHINA],
        ['HK', Country.HONG_KONG],
        ['NL', Country.NETHERLANDS],
        ['US', Country.UNITED_STATES]
    ]);
    return CountryConverter;
}());
exports.CountryConverter = CountryConverter;
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["GRAMS"] = "GRAMS";
    WeightUnit["KILOGRAMS"] = "KILOGRAMS";
    WeightUnit["OUNCES"] = "OUNCES";
    WeightUnit["POUNDS"] = "POUNDS";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
var WeightUnitConverter = /** @class */ (function () {
    function WeightUnitConverter() {
    }
    WeightUnitConverter.gramsTo = function (valueInGrams, targetWeightUnit) {
        switch (targetWeightUnit) {
            case WeightUnit.GRAMS:
                return valueInGrams;
            case WeightUnit.KILOGRAMS:
                return valueInGrams / 1000;
            case WeightUnit.OUNCES:
                return valueInGrams * 0.035274;
            case WeightUnit.POUNDS:
                return valueInGrams * 0.00220462;
            default:
                throw new Exception("Cannot compute the grams equivalent of the unknown target measurement unit " + targetWeightUnit);
        }
    };
    return WeightUnitConverter;
}());
exports.WeightUnitConverter = WeightUnitConverter;
var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
    Currency["HKD"] = "HKD";
    Currency["RMB"] = "RMB";
})(Currency = exports.Currency || (exports.Currency = {}));
var Money = /** @class */ (function () {
    function Money() {
    }
    Money.isUndefined = function (money) {
        return money.amount === -1;
    };
    Money.undefined = function (currency) {
        return {
            currency: currency,
            amount: -1
        };
    };
    Money.multiply = function (money, multiplicationFactor) {
        return { currency: money.currency, amount: money.amount * multiplicationFactor };
    };
    Money.add = function (money1, money2) {
        return { currency: money1.currency, amount: money1.amount + money2.amount };
    };
    Money.round = function (money, decimals) {
        if (decimals === void 0) { decimals = 2; }
        var d = Math.pow(10, decimals);
        return { currency: money.currency, amount: Math.round((money.amount + Number.EPSILON) * d) / d };
    };
    return Money;
}());
exports.Money = Money;
var TranslatedString = /** @class */ (function () {
    function TranslatedString() {
    }
    TranslatedString.languageValue = function (s, language) {
        switch (language) {
            case Language.ENGLISH:
                return s.en ? s.en : TranslatedString.missingTranslation;
            case Language.DUTCH:
                return s.nl ? s.nl : TranslatedString.missingTranslation;
            case Language.FRENCH:
                return s.fr ? s.fr : TranslatedString.missingTranslation;
            case Language.GERMAN:
                return s.du ? s.du : TranslatedString.missingTranslation;
            case Language.SPANISH:
                return s.es ? s.es : TranslatedString.missingTranslation;
            default:
                return TranslatedString.missingTranslation;
        }
    };
    TranslatedString.missingTranslation = '{missing_translation}';
    return TranslatedString;
}());
exports.TranslatedString = TranslatedString;
var Language;
(function (Language) {
    Language["ENGLISH"] = "ENGLISH";
    Language["DUTCH"] = "DUTCH";
    Language["FRENCH"] = "FRENCH";
    Language["GERMAN"] = "GERMAN";
    Language["SPANISH"] = "SPANISH";
})(Language = exports.Language || (exports.Language = {}));
var MimeType;
(function (MimeType) {
    MimeType["_3DM"] = "model/vnd.3dm";
    MimeType["PNG"] = "image/png";
    MimeType["SVG"] = "image/svg+xml";
    MimeType["GLB"] = "model/gltf-binary";
    MimeType["OTF"] = "application/x-font-opentype";
    MimeType["HDRI"] = "image/hdri";
    MimeType["HULL"] = "application/x-hull";
    MimeType["JS"] = "text/javascript";
    MimeType["JSON"] = "application/json";
})(MimeType = exports.MimeType || (exports.MimeType = {}));
var ContentType = /** @class */ (function () {
    function ContentType() {
    }
    ContentType.mimeTypeToCharset = function (mimeType) {
        var textCharset = 'UTF-8';
        var binaryCharset = 'binary';
        if (mimeType === MimeType.JSON || mimeType === MimeType.SVG || mimeType === MimeType.HULL) {
            return textCharset;
        }
        return binaryCharset;
    };
    ContentType.mimeTypeToFileExtension = function (mimeType) {
        for (var _i = 0, _a = Array.from(ContentType.extensionsToMimeTypes.keys()); _i < _a.length; _i++) {
            var extension = _a[_i];
            if (mimeType === ContentType.extensionsToMimeTypes.get(extension)) {
                return extension;
            }
        }
        return undefined;
    };
    ContentType.filenameToMimeType = function (filename) {
        for (var _i = 0, _a = Array.from(ContentType.extensionsToMimeTypes.keys()); _i < _a.length; _i++) {
            var extension = _a[_i];
            if (filename.endsWith(extension)) {
                return ContentType.extensionsToMimeTypes.get(extension);
            }
        }
        return undefined;
    };
    ContentType.extensionsToMimeTypes = new Map([
        ['.3dm', MimeType._3DM],
        ['.png', MimeType.PNG],
        ['.svg', MimeType.SVG],
        ['.glb', MimeType.GLB],
        ['.otf', MimeType.OTF],
        ['.env', MimeType.HDRI],
        ['.hull', MimeType.HULL],
        ['.js', MimeType.JS],
        ['.json', MimeType.JSON]
    ]);
    return ContentType;
}());
exports.ContentType = ContentType;
if (!('toJSON' in Error.prototype))
    Object.defineProperty(Error.prototype, 'toJSON', {
        value: function () {
            var alt = {};
            Object.getOwnPropertyNames(this).forEach(function (key) {
                alt[key] = this[key];
            }, this);
            return alt;
        },
        configurable: true,
        writable: true
    });
var Exception = /** @class */ (function (_super) {
    __extends(Exception, _super);
    function Exception(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
        Object.setPrototypeOf(_this, _newTarget.prototype); // restore prototype chain
        _this.name = Exception.name; // stack traces display correctly now
        return _this;
    }
    return Exception;
}(Error));
exports.Exception = Exception;
var SecurityException = /** @class */ (function (_super) {
    __extends(SecurityException, _super);
    function SecurityException(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
        Object.setPrototypeOf(_this, _newTarget.prototype); // restore prototype chain
        _this.name = SecurityException.name; // stack traces display correctly now
        return _this;
    }
    return SecurityException;
}(Error));
exports.SecurityException = SecurityException;
